// extracted by mini-css-extract-plugin
module.exports = {"mensajeContenedor":"NoHayDatos_mensajeContenedor__2ucg2"};